import { render, staticRenderFns } from "./CostForm.vue?vue&type=template&id=2dc711d8&"
import script from "./CostForm.vue?vue&type=script&lang=js&"
export * from "./CostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports